import axios from 'axios'

export const setFirstAutoshipDiscountOrderMetadata = async (
  originalPrice,
  discountedPrice,
  productId
) => {
  let cart = window.Snipcart.api.cart.get()
  if (!cart) {
    cart = await window.Snipcart.api.cart.start()
  }
  const hasFirstAutoship = cart.metadata && 'firstAutoship' in cart.metadata
  let currentDiscountedTotal = 0
  if (hasFirstAutoship) {
    currentDiscountedTotal = cart.metadata.discountedTotal
  }
  const productDiscount = (
    Number(originalPrice) - Number(discountedPrice)
  ).toFixed(2)
  const discountedTotal = (
    Number(currentDiscountedTotal) + Number(productDiscount)
  ).toFixed(2)
  window.Snipcart.api.cart.metadata({
    ...cart.metadata,
    firstAutoship: true,
    discountedTotal,
    discountedProducts:
      cart.metadata.discountedProducts != null
        ? {
            ...cart.metadata.discountedProducts,
            [productId]: productDiscount
          }
        : { [productId]: productDiscount }
  })
  return true
}

export default async price => {
  const user = window.Snipcart.api.user.current()
  if (!user || typeof user === 'undefined') {
    return false
  }
  const response = await axios.get(
    `${process.env.REACT_APP_SNIPCART_VALIDATOR_DOMAIN}api/validate-first-autoship/${user.id}`,
    {
      headers: {
        Authorization: `Basic ${process.env.REACT_APP_SNIPCART_VALIDATOR_AUTH_TOKEN}`
      }
    }
  )
  const { isApplied } = response.data
  if (isApplied) {
    return false
  }

  const discount = (price * 20) / 100
  const discountedPrice = price - discount
  return String(discountedPrice.toFixed(2))
}
